/** @format */
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchStats, clearStats } from "../../../Poker/redux/slices/statsSlice";
import { usePlayer, useA23Token, useAccessToken } from "@/src/hooks/data/useLobby";

export function useStats({ gameType, gameVariant, durationSelectedObj }) {
	const dispatch = useDispatch();

	// Select stats slice for given gameType
	const stats = useSelector((state) => state.stats[gameType.toLowerCase()]);
	const player = usePlayer();
	const a23Token = useA23Token();
	const accessToken = useAccessToken();

	useEffect(() => {
		if (!gameType || !gameVariant || !durationSelectedObj) return;

		// Fetch data when dependencies change
		dispatch(fetchStats({ gameType, gameVariant, durationSelectedObj, player, a23Token, accessToken }));

		// Optional: cleanup on unmount or when gameType changes
		return () => {
			dispatch(clearStats(gameType.toLowerCase()));
		};
	}, [dispatch, gameType, gameVariant, durationSelectedObj]);

	return {
		statsData: stats?.data,
		isLoading: stats?.loading,
		isError: !!stats?.error,
		error: stats?.error,
	};
}
